import type { Conference } from "../../api.js";
import { ProgrammeWorkspace } from "../programme/ProgrammeWorkspace.js";
import { StageHeader } from "./StageScaffold.js";

export function ProgrammeStage({ conference }: { conference: Conference }) {
  return <div className="conference-stage conference-stage--programme">
    <StageHeader title="Programme" description="Shape accepted work into a clear schedule, resolve conflicts, and publish a participant-safe version." />
    <ProgrammeWorkspace conference={conference} />
  </div>;
}
